export const GET_ACTIVE = 'GET_ACTIVE';
export const UPDATE_SHIFT = 'UPDATE_SHIFT';
export const SHIFT_DONE = 'SHIFT_DONE';

export const TIMER_IN = 'TIMER_IN';
export const RESET_TIMER = 'RESET_TIMER';
export const START_TIMER = 'START_TIMER';
